<template>
    <div>
        <div v-if="!$route.meta.keepAlive">
            <router-view />
        </div>
        <div v-if="$route.meta.keepAlive">
            <router-view />
            <bottomMenu />
        </div>
    </div>
</template>

<script>
import bottomMenu from "./components/bottomMenu";
import { httpGetRequest } from "./axios/get";
import { httpPost } from "./axios/index";
import share from "./util/share.js";
import wx from "weixin-js-sdk";

export default {
    components: {
        bottomMenu
    },

    data() {
        return {};
    },
    created() {
        // share({name:1,age:32});
    },
    methods: {
        // 返回上一页
    },
    mounted() {
        // var isLogin = sessionStorage.getItem("isLogin");
        // if(!isLogin){
        //     this.$router.push("/login")
        // }
    }
};
</script>

<style>
.top {
    background: #22d9d9;
    color: #fff;
    font-size: 1rem;
    text-align: center;
}
.van-nav-bar {
    background: #22d9d9 !important;
}
.van-nav-bar .van-icon,
.van-nav-bar__text,
.van-nav-bar__title {
    color: #fff !important;
}
</style>
